'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes", "sx"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ConversationSubtitle } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { useChatConversationUtilityClasses } from "./chatConversationClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatConversationSubtitle');
const ChatConversationSubtitleStyled = styled('p', {
  name: 'MuiChatConversation',
  slot: 'Subtitle',
  overridesResolver: (_, styles) => styles.subtitle
})(({
  theme
}) => ({
  margin: 0,
  fontSize: theme.typography.caption.fontSize,
  color: (theme.vars || theme).palette.text.secondary,
  lineHeight: 1.4,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));
const ChatConversationSubtitle = /*#__PURE__*/React.forwardRef(function ChatConversationSubtitle(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatConversationSubtitle'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp,
      sx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatConversationUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(ConversationSubtitle, _extends({
    ref: ref
  }, other, {
    slots: _extends({
      subtitle: slots?.subtitle ?? ChatConversationSubtitleStyled
    }, slots),
    slotProps: _extends({}, slotProps, {
      subtitle: _extends({
        className: clsx(classes.subtitle, className),
        sx
      }, slotProps?.subtitle)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatConversationSubtitle.displayName = "ChatConversationSubtitle";
process.env.NODE_ENV !== "production" ? ChatConversationSubtitle.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object,
  className: PropTypes.string,
  slotProps: PropTypes.object,
  slots: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export { ChatConversationSubtitle };